// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarEtiquetaPessoaService = async (valuesEtiqueta: any) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/etiqueta-pessoa`;

    try {
      const response = await axios.post(URL, valuesEtiqueta, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
